import { render } from "./CursoDropdown.vue?vue&type=template&id=0dd237e6&scoped=true"
import script from "./CursoDropdown.vue?vue&type=script&lang=js"
export * from "./CursoDropdown.vue?vue&type=script&lang=js"

import "./CursoDropdown.vue?vue&type=style&index=0&id=0dd237e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd237e6"]])

export default __exports__